import Label from '@allesauto/core/label';
import LikeButton from '@allesauto/core/likeButton';
import LoaderOverlay from '@allesauto/core/loaderOverlay';
import TextLink from '@allesauto/core/textLink';
import { useWhiteLabel } from '@allesauto/core/whiteLabel';
import { isAuregoShop } from '@allesauto/utils/funcs.ts';
import { ChevronLeft16 } from '@carbon/icons-react';
import clsx from 'clsx';
import { useRouter } from 'next/router';
import React, { FC, useCallback, useEffect, useState } from 'react';

import { getFiltersFromLocalStorage } from '@/global/hooks/routerHistory';

interface MainActionsProps {
  labelText?: string;
  linkText?: string;
  noLabel?: boolean;
  isWhiteLabel?: boolean;
  onLikeClick?: () => void;
  isAccessory?: boolean;
  hasFavorites?: boolean;
  returnUrl?: string;
}

const MainActions: FC<React.PropsWithChildren<MainActionsProps>> = ({
  labelText,
  linkText,
  noLabel = false,
  isAccessory = false,
  hasFavorites = false,
  isWhiteLabel = false,
  returnUrl,
}) => {
  const router = useRouter();
  const [loading, setLoading] = useState<boolean>(false);
  const whiteLabel = useWhiteLabel();

  const classname = {
    textLink:
      'col-end-24 col-start-2 hidden md:block md:col-end-7 md:col-start-2',
    label: clsx(
      ' col-end-24 col-start-2 flex items-center justify-between md:col-end-18 md:col-start-8',
      noLabel && '!justify-end'
    ),
  };

  const onFavoritesClick = () => {
    // TODO: implement add to favorites
  };

  useEffect(() => {
    const handleRouteChangeComplete = () => {
      setLoading(false);
    };

    router.events.on('routeChangeComplete', handleRouteChangeComplete);

    return () => {
      router.events.off('routeChangeComplete', handleRouteChangeComplete);
    };
  }, [router]);

  const goBackToCarPcP = useCallback(() => {
    if (returnUrl) {
      window.location.href = returnUrl;
      return;
    }

    setLoading(true);

    // Retrieve the selected filters from local storage
    const selectedFilters = getFiltersFromLocalStorage();

    return router.push(
      `/auto-kaufen/?${new URLSearchParams(selectedFilters).toString()}`
    );
  }, [router, returnUrl]);

  const goBackToAccessoryPcP = useCallback(() => {
    setLoading(true);

    // Retrieve the selected filters from local storage
    const selectedFilters = getFiltersFromLocalStorage();

    return router.push(
      `/zubehoer-kaufen/?${new URLSearchParams(selectedFilters).toString()}`
    );
  }, [router]);

  return (
    <>
      {loading && <LoaderOverlay hasLoader={false} hasZeroOpacity />}
      {linkText && (
        <div className={classname.textLink} data-hide-for-print="">
          <TextLink
            isLoading={loading}
            text={linkText}
            onClick={isAccessory ? goBackToAccessoryPcP : goBackToCarPcP}
            icon={<ChevronLeft16 />}
            id="link--go-back"
          />
        </div>
      )}
      <div className={classname.label}>
        {labelText && (
          <Label
            text={labelText}
            customClassName={isAuregoShop(whiteLabel) ? '!bg-transparent' : ''}
          />
        )}
        <div>
          {hasFavorites && !isWhiteLabel && (
            <LikeButton onClick={onFavoritesClick} darkBg={true} />
          )}
        </div>
      </div>
    </>
  );
};

export default MainActions;
